import * as DateFns from 'date-fns';
import AbortController from 'abort-controller';
import { routeToSpecificScope } from '../../helpers/helpersts';

import * as eventsType from '../types';
import { SERVER } from '../../config/server.config';
import { requestData, requestAsJson } from '../../config/services/datasets';
import { msToTime, getTeamData} from '../../helpers/helpers';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { changeToLivePractice, toMetaDataEvents, updateMetaDataEvent, updatePracticeStartTime } from './dataEvents';
import { CONTROLLER_SET, FORMAT_DATE_ROUTE, PAST_PRACTICE } from '../../config/constants';
import { loadEvents } from './events';
import { changePracticeSavedSuccessfullyFlag } from './flags';

export const setEditableManager = (editable) => {
  return {
    type: eventsType.SET_EDITABLE_MANAGER,
    editable: editable
  };
};

export const replaceManageData = (data, gameId) => {
  return {
    type: eventsType.REPLACE_MANAGE_DATA_EVENT,
    manage: data,
    gameId: gameId
  };
};

export const patchManageData = (data, gameId) => {
  return {
    type: eventsType.PATCH_MANAGE_DATA_EVENT,
    manage: data,
    gameId: gameId
  };
};

export const getPractice = (gameId, mongoId, league, isMobile) => {
  return async dispatch => {
    const controller = new AbortController();
    CONTROLLER_SET.add(controller);
    const results = await requestData(SERVER.MANAGE_GET(mongoId, league, isMobile), { signal: controller.signal });
    CONTROLLER_SET.delete(controller);
    if (results) {
      dispatch(replaceManageData(results[0], gameId));
      dispatch(updateMetaDataEvent(gameId, toMetaDataEvents(results[0])));
    }
  };
};

export const updatePractice = (practice, gameId, id, league, loader, type, reprocess, isMobile) => {
  const body = {};
  // object building START
  const cleanDrills = practice.drills ? practice.drills.map(drill => {
    if (drill.drillId) {
      delete drill.drillId;
    }
    return drill;
  }) : [];
  if (practice.drills && practice.drills[0] && practice.drills[0].startTs) {
    practice.start = practice.drills[0].startTs;
  }

  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();

      if (stringKey !== 'drills') {
        body[stringKey] = practice[stringKey];
      } else {
        body[stringKey] = cleanDrills;
      }
    }
  }

  if (practice.end && practice.end > 0) {
    let maxEndTs = 0;
    cleanDrills.forEach(drill => {
      maxEndTs = Math.max(drill.endTs, maxEndTs);
      return drill;
    });

    if(reprocess === false){
      body['dsUpdateTimeStampChange'] = false;
    }else{
    body['dsUpdateTimeStampChange'] = true;
    }

    // updating the practice end timestamp
    if(maxEndTs > 0){
      body['end'] = maxEndTs;
      body['endScheduleTs'] = maxEndTs;
    }else if (type === PAST_PRACTICE) {
      body['end'] = practice.start+1;
      body['endScheduleTs'] = practice.start+1;
    }
  }
  // object building FINISH
  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (loader) {
      dispatch(addLoadingFlag(scope));
    }
    const response = await fetch(SERVER.MANAGE_UPDATE(practice._id, practice.teamId, league, isMobile), request);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    const responseJson = await response.json();
    if (responseJson) {
      dispatch(replaceManageData(responseJson.results[0], gameId));
      dispatch(updatePracticeStartTime(gameId, responseJson.results[0]));
      dispatch(getPractice(gameId, id, league, isMobile));
      if(reprocess !== false){
        dispatch(changePracticeSavedSuccessfullyFlag(true));
      }
    } else {
      alert('Practice was not saved correctly. Please try again');
    }
    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};
// COMBINE EVENTS

export const createCombineEvent=(practiceId, combineEvent, gameId, league)=>{
  return async (dispatch) =>{
  fetch(SERVER.CREATE_COMBINE_OBJECT(practiceId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(combineEvent)
  })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .finally(() => {
      dispatch(getPractice(practiceId, gameId, league, false));
    });
  };
};

export const updateCombineEvent=(practiceId, combineEvent, combineEventId, gameId, league)=>{
  return async (dispatch) =>{
  fetch(SERVER.UPDATE_COMBINE_OBJECT(practiceId, combineEventId), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(combineEvent)
  })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    });
  };
};

export const finalizeCombine=(practiceId)=>{
  return async (dispatch) =>{
  fetch(SERVER.FINALIZE_COMBINE(practiceId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    });
  };
  
};

export const startPractice = (practice, gameId) => {
  const now = (new Date()).getTime();

  // START firstBody BUILDING
  const cleanDrills = JSON.parse(JSON.stringify(practice.drills)).map(drill => {
    delete drill.drillId;
    return drill;
  });
  cleanDrills[0]['startTs'] = now;
  cleanDrills[0]['state'] = 'START';
  cleanDrills[0]['session_id'] = 1;
  const firstBody = {};
  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        firstBody[stringKey] = practice[stringKey];
      } else {
        firstBody[stringKey] = cleanDrills;
      }
    }
  }
  firstBody['currentDrill'] = practice.drills[0].drillType;
  firstBody['currentDrillIndex'] = 0;
  firstBody['dsUpdateTimeStampChange'] = true;
  firstBody['isStarted'] = true;
  firstBody['lastDrillIndex'] = 0; // in nexus, this never changes across requests
  firstBody['lastDrillStartTime'] = now;
  firstBody['start'] = now;
  firstBody['stepIndex'] = 1;
  firstBody['totalElapsedTime'] = 0;
  delete firstBody._id;
  // END firstBody BUILDING

  const secondBody = {
    home_team_id: practice.teamId,
    home_team_name: practice.siteName,
    intensity: practice.intensity,
    roofType: practice.rooftype,
    league: practice.league,
    name: practice.name,
    notes: '',
    site_id: practice.siteId,
    start_time: now,
    type: practice.type,
    scheduleId: practice._id
  };

  const firstPutRequest = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(firstBody)
  };

  const postRequest = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(secondBody)
  };

  const teamData = getTeamData(practice.teamId, practice.league);
  return async dispatch => {
    // const firstResults =
    const firstUrl = SERVER.MANAGE_UPDATE(practice._id, practice.teamId, practice.league);
    const firstResults = await requestAsJson(firstUrl, firstPutRequest);
    // can make dispatch before calling
    if (firstResults.results && firstResults.results[0]) {
      dispatch(updateMetaDataEvent(gameId, firstResults.results));
      const secondUrl = SERVER.MANAGE_START_PRACTICE(practice.teamId, practice.league);
      const secondResults = await requestAsJson(secondUrl, postRequest);
      if (Array.isArray(secondResults.results) && secondResults.results.length && secondResults.results[0] && secondResults.results[0].game_id && 
      secondResults.results[0].dataset_id && secondResults.results[0]._id) {
        const thirdUrl = SERVER.MANAGE_CHECK_REPLICA(practice.teamId, secondResults.results[0].game_id, practice.league);
        const slackCallResults = await fetch(thirdUrl);
        if (!slackCallResults.ok) {
          alert (`PUT Request to ${thirdUrl} for practice named ${practice.name} ${teamData && teamData.teamFullName ? `for team ${teamData.teamFullName} ` : ''}
             ${slackCallResults.statusText || slackCallResults.message ? `has failed with error: ${slackCallResults.statusText || slackCallResults.message}` : 'has failed'}`);
        }

        firstBody['dataset_id'] = secondResults.results[0].dataset_id;
        firstBody['dataset_ref_id'] = secondResults.results[0]._id;
        firstBody['totalElapsedTime'] = 0;

        const lastPut = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(firstBody)
        };
        const fourthUrl = SERVER.MANAGE_UPDATE(practice._id, practice.teamId, practice.league);
        const lastPutResults = await requestAsJson(fourthUrl, lastPut);
        if (lastPutResults.results && lastPutResults.results[0]) {
          dispatch(replaceManageData(lastPutResults.results[0], gameId));
          dispatch(updateMetaDataEvent(gameId, toMetaDataEvents(lastPutResults.results[0])));
          if (secondResults.results[0] && secondResults.results[0].game_id) {
            dispatch(changeToLivePractice(practice._id, secondResults.results[0].game_id, practice.start, secondResults.results[0].start_time));
          }
        } else {
          alert('The practice did not start successfully. Please try again.');
        }
      } else {
        if (!Array.isArray(secondResults.results) || !secondResults.results.length) {
          alert('The practice did not start successfully. Please try again.');
        }
      }
    } else {
      alert('The practice did not start successfully. Please try again.');
    }
  };
};

export const startPracticeMobile = (practice, gameId) => {
  const now = (new Date()).getTime();

  // START firstBody BUILDING
  const cleanDrills = JSON.parse(JSON.stringify(practice.drills)).map(drill => {
    delete drill.drillId;
    return drill;
  });
  cleanDrills[0]['startTs'] = now;
  cleanDrills[0]['state'] = 'START';
  cleanDrills[0]['session_id'] = 1;
  const firstBody = {};
  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        firstBody[stringKey] = practice[stringKey];
      } else {
        firstBody[stringKey] = cleanDrills;
      }
    }
  }
  firstBody['currentDrill'] = practice.drills[0].drillType;
  firstBody['currentDrillIndex'] = 0;
  firstBody['dsUpdateTimeStampChange'] = true;
  firstBody['isStarted'] = true;
  firstBody['lastDrillIndex'] = 0; // in nexus, this never changes across requests
  firstBody['lastDrillStartTime'] = now;
  firstBody['start'] = now;
  firstBody['stepIndex'] = 1;
  firstBody['totalElapsedTime'] = 0;
  delete firstBody._id;

  const firstPostRequest = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(firstBody)
  };

  const teamData = getTeamData(practice.teamId, practice.league);
  return async dispatch => {
  const url = SERVER.MANAGE_START_PRACTICE_MOBILE(practice._id, practice.teamId, practice.league);
  const response = await requestAsJson(url, firstPostRequest);
      if (Array.isArray(response.results) && response.results.length && response.results[0] && response.results[0].game_id && response.results[0].dataset_id && response.results[0]._id) {
          if (response.results[0] && response.results[0].game_id) {
            dispatch(changeToLivePractice(practice._id, response.results[0].game_id, practice.start, response.results[0].start_time));
          }
        }else if(response.code === 1){
          alert('The practice did not start successfully. Please try again.');
        }
  };
};

export const endPeriod = (practice, index, gameId, skip, isMobile) => {
  const now = (new Date()).getTime();
  const body = {};
  const cleanDrills = practice.drills.map(drill => {
    delete drill.drillId;
    return drill;
  });

  cleanDrills[index]['endTs'] = now;
  cleanDrills[index]['state'] = 'FINISH';

  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        body[stringKey] = practice[stringKey];
      } else {
        body[stringKey] = cleanDrills;
      }
    }
  }

  body['isStarted'] = false;
  body['lastDrillStartTime'] = now;
  body['currentDrillIndex'] = body['currentDrillIndex'] + 1;
  body['totalElapsedTime'] = msToTime(now - body.start);
  delete body._id;
  // need to calculate totalElapsedTime yet

  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };
  return async dispatch => {
    const results = await requestData(SERVER.MANAGE_UPDATE(practice._id, practice.teamId, practice.league, isMobile), request);
    if (results[0]) {
      dispatch(patchManageData(results[0], gameId));
      dispatch(updateMetaDataEvent(gameId, toMetaDataEvents(results[0])));
      if(skip){
        dispatch(startPeriod(results[0], index +1, gameId, practice._id, skip, isMobile));
      }
    }
  };
};

export const startPeriod = (practice, index, gameId, practiceId, skip, isMobile) => {
  const now = (new Date()).getTime();

  const body = {};
  const cleanDrills = practice.drills.map(drill => {
    delete drill.drillId;
    drill.startTs = Math.min(drill.startTs, now);
    drill.endTs = Math.min(drill.endTs, now);
    return drill;
  });
  if(skip){
    const startTime = practice.drills[index -1].endTs;
    cleanDrills[index]['startTs'] = startTime +100;
    cleanDrills[index]['state'] = 'START';
    cleanDrills[index]['session_id'] = index + 1;
  }else{
    cleanDrills[index]['startTs'] = now;
    cleanDrills[index]['state'] = 'START';
    cleanDrills[index]['session_id'] = index + 1;
  }
  

  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        body[stringKey] = practice[stringKey];
      } else {
        body[stringKey] = cleanDrills;
      }
    }
  }
  body['isStarted'] = true;
  body['lastDrillStartTime'] = now;
  body['totalElapsedTime'] = msToTime(now - body.start);
  body['currentDrill'] = cleanDrills[body.currentDrillIndex].drillType;
  delete body._id;
  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async dispatch => {
    const results = await requestData(SERVER.MANAGE_UPDATE(practice._id?practice._id:practiceId, practice.teamId, practice.league, isMobile), request);
    if (results && results[0]) {
      dispatch(patchManageData(results[0], gameId));
      dispatch(updateMetaDataEvent(gameId, toMetaDataEvents(results[0])));
    }
  };
};

export const endPractice = (practice, drills, gameId, isMobile) => {
  // first update, then slack
  const now = (new Date()).getTime();
  const body = {};

  let sessionId = -1;
  const endedDrills = drills.map(drill => {
    if (drill.session_id && !Number.isNaN(+drill.session_id)) {
      sessionId = Math.max(sessionId, drill.session_id);
    }
    delete drill.drillId;
    if (!drill.startTs) {
      drill['startTs'] = now;
    }
    if (!drill.session_id) {
      drill['session_id'] = sessionId + 1;
      ++sessionId;
    }
    if (!drill.endTs) {
      drill['endTs'] = now;
    }
    drill['state'] = 'FINISH';
    drill.startTs = Math.min(drill.startTs, now);
    drill.endTs = Math.min(drill.endTs, now);
    return drill;
  });

  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        body[stringKey] = practice[stringKey];
      } else {
        body[stringKey] = endedDrills;
      }
    }
  }

  body['end'] = now;
  body['endScheduleTs'] = now;
  body['stepIndex'] = 2;
  body['isStarted'] = true;
  body['currentDrillIndex'] = endedDrills.length;
  body['currentDrill'] = '';
  body['dsUpdateTimeStampChange'] = true;
  delete body._id;

  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const putResponse = await fetch(SERVER.MANAGE_UPDATE(practice._id, practice.teamId, practice.league, isMobile), request);
    if (putResponse.ok) {
      const newData = await putResponse.json();
      dispatch(replaceManageData(newData.results[0], gameId));
    }
    await requestData(SERVER.MANAGE_STOP_PRACTICE(practice.teamId, practice.league, isMobile));
    dispatch(updateMetaDataEvent(gameId, { type: PAST_PRACTICE }));
    const nowDate = new Date();
    dispatch(subLoadingFlag(scope));
    dispatch(loadEvents(true, true, true, `/schedule/month/${DateFns.format(new Date(nowDate), FORMAT_DATE_ROUTE)}`, true, isMobile));
  };
};

export const partialReprocess = (gameId, playerList, practice, id, league, type) =>{
  const body=playerList;
    const jsonBody = JSON.stringify(body);
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    };
    return async (dispatch) =>{
      const response = await fetch(SERVER.PARTIAL_REPROCESS(gameId), request);
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const responseJson = await response.json();
      if (responseJson) {
        dispatch(updatePractice(practice, gameId, id, league, true, type ));
      }
    };
    
};
